/// <reference path='_all.ts' />


// CHEAT SHEET: http://ivision.com/wp-content/uploads/AngularJS_v2.pdf

/**
 * The main TodoMVC app module.
 *
 * @type {angular.Module}
 */
module blog {
  'use strict';

  var footer = angular.module('blog', ['ngSanitize', 'ngMessages'])
    .controller('blogCtrl', BlogCtrl)
    .controller('eventCtrl', EventCtrl)
    .controller('salesToolsCtrl', SalesToolsCtrl)
    .controller('blogDetailCtrl', BlogDetailCtrl)
    .controller('berechnungCtrl', BerechnungCtrl)
    .controller('scrubberCtrl', ScrubberCtrl)
    .directive('blogEntry', BlogEntryDirective)
    .service('blogService', blogService);
}